export const getTableColumns = (tableSettings = {}) => {
  const columns = [];
  // Row keys — these are fixed identifiers
  // Row keys — fixed identifiers
  if (Array.isArray(tableSettings.row_keys)) {
    tableSettings.row_keys.forEach(col => {
      // Base row key column
      const baseCol = {
        ...col,
        type: col?.cellType ?? col.type ?? '',
        isRowKey: true,
        editable: false, // row keys cannot be edited per cell
        field: col.field,
        headerName: col.headerName ?? col.field,
        hidden: false
      };

      // If row key has colType 'sub', create extra column and hide original
      if (col.cellType === 'sub') {
        columns.push({
          ...baseCol,
          field: `${baseCol.field}_sub`,
          headerName: `${baseCol.headerName}`,
          hidden: false
        });
        baseCol.hide = true; // hide original row key column
        baseCol.filter = {
          ...(baseCol.filter ?? {}),
          allow: false
        };
      }

      columns.push(baseCol);
    });
  }

  // Column keys — these map to your payload's value or header
  if (Array.isArray(tableSettings.column_keys)) {
    tableSettings.column_keys.forEach(col => {
      // Base column
      const baseCol = {
        ...col,
        isColumnKey: true,
        editable: col.editable ?? true,
        field: col.value ?? col.field,
        headerName: col.headerName ?? col.field,
        hidden: false
      };

      // If it's a "sub" type, create extra column and hide original
      if (col.cellType === 'sub') {
        columns.push({
          ...baseCol,
          field: `${baseCol.field}_sub`,
          headerName: `${baseCol.headerName}`,
          hidden: false
        });
        baseCol.hide = true; // hide the original
        baseCol.filter = {
          ...(baseCol.filter ?? {}),
          allow: false
        };
      }

      columns.push(baseCol);
    });
  }

  return columns;
};

export const getFieldKeys = (tableSettings = {}) => {
  const keys = [];

  if (Array.isArray(tableSettings.row_keys)) {
    keys.push(...tableSettings.row_keys.map(col => col.field).filter(Boolean));
  }

  if (Array.isArray(tableSettings.column_keys)) {
    keys.push(
      ...tableSettings.column_keys.map(col => col.field).filter(Boolean)
    );
  }

  // Optional: ensure uniqueness
  return [...new Set(keys)];
};

export const getRowKeys = (tableSettings = {}) => {
  const keys = [];

  if (Array.isArray(tableSettings.row_keys)) {
    keys.push(...tableSettings.row_keys.map(col => col.field).filter(Boolean));
  }

  // Optional: ensure uniqueness
  return [...new Set(keys)];
};

export const resolveColumnField = (columnKeys = [], col) => {
  if (!col) return null;

  return (
    columnKeys.find(
      c => c.headerName === col.headerName || c.value === col.value
    )?.field ?? null
  );
};

export const upsertTableData = (prev, nextRow) => {
  const idx = prev.findIndex(
    r => r.key === nextRow.key && r.id2 === nextRow.id2 && r.id3 === nextRow.id3
  );

  if (idx !== -1) {
    const copy = [...prev];
    copy[idx] = { ...copy[idx], value: nextRow.value };
    return copy;
  }

  return [...prev, nextRow];
};
